import React from 'react';
import {
  Link,
} from 'react-router-dom';
import './Sec1.css';

const Menu = () => (
  <div>
    <br /><br />
    <h2>Service Information and Documents</h2>
    <ul>
      <li>
        <Link to='/services' style={{textDecoration: 'none'}}>
          <p>Service Information</p>
        </Link>
      </li>
      <li>
        <Link to='/documents' style={{textDecoration: 'none'}}>
          <p>Documents and Policies</p>
        </Link>
      </li>
      <li>
        <Link to='/rates' style={{textDecoration: 'none'}}>
          <p>Fiber Rates</p>
        </Link>
      </li>
    </ul>
  </div>
);

export default Menu;


// WEBPACK FOOTER //
// ./src/components/sections/Menu.js